import { createActionCreator } from '../utils/helpers';

import { sseAccessToken } from './types';

export const requestSseAccessToken = createActionCreator(
  sseAccessToken.request,
  'resolve',
  'reject',
);
